import React from "react";
import {Box} from "@mantine/core";
import {IInstructionStep} from "@/protocols/types/protocol.ts";
import {IInstructionStepDefinition} from "@/protocols/types/protocolDefinitions.ts";
import '@mdxeditor/editor/style.css'
import {MarkdownEditor} from "@/common/components/MarkdownEditor";
import {DeepPartial} from "@/utils/types/DeepPartial";
import {TWorkflow} from "../StepView";

/** Union type for Instruction steps (both execution and planning modes) */
type InstructionStep = IInstructionStep | IInstructionStepDefinition;

export interface InstructionStepViewProps {
    step: InstructionStep;
    onChange: (updates: DeepPartial<InstructionStep>) => void;
    workflow?: TWorkflow;
}

/**
 * View component for instruction steps.
 * - Planning mode: Renders MarkdownEditor in editable mode
 * - Execution mode: Renders MarkdownEditor in readonly mode
 * - Review mode: Renders MarkdownEditor in readonly mode (times in StepRow header)
 * - Review_edit mode: Renders MarkdownEditor in editable mode with Cancel/Update
 */
export const InstructionStepView: React.FC<InstructionStepViewProps> = ({
                                                                            step,
                                                                            onChange,
                                                                            workflow = "session",
                                                                        }) => {
    const handleInstructionsChange = (value: string) => {
        onChange({
            instructions: value
        });
    };

    return (
        <Box style={{display: "flex", flexDirection: "column", gridColumn: "1 / -1"}}>
            <MarkdownEditor
                editingMode={workflow === "planning"
                    ? "full"
                    : workflow === "session" || workflow === "review_edit"
                        ? "checkboxes"
                        : "none"}
                key={`${step.id}-${workflow}`}
                markdown={step.instructions || ""}
                onChange={handleInstructionsChange}
                mdDataTestId="input-instructions"
            />
        </Box>
    );
};